
export const statementsColoumns = () => {
  
  return [
    {
      name: 'Funder Type',
      selector: row => row.funder_type,
      sortable: true,
    },
    {
      name: 'Funder Name',
      selector:  row =>
      row.funder_name,

      sortable: true,
    },
    {
      name: 'Type',
      selector: row => row.transfer_type,
      sortable: true,
    },
    {
      name: 'Date',
      selector: row => row.transfer_date,
      
      sortable: true,
    },
    {
      name: 'Total',
      selector: row => '₹' + row.transfer_amount,
      sortable: true,
    },
    
  ]
}
